<template>
    <el-dialog
        :visible.sync="Visible"
        :title="title"
        v-loading="dataLoading"
        element-loading-background="rgba(0, 0, 0, 0.1)"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <el-row
            style="margin-bottom: 2px; margin-top: -15px"
            v-if="type == '门店收入类型' && moduleMark == 'POS'"
        >
            <el-col :span="24">
                <span class="right-15">收入类型:</span>
                <el-button
                    v-for="(item, index) in incomeTypeList"
                    :key="index"
                    size="medium"
                    :type="CurrnetMID == item.id ? 'primary' : ''"
                    @click="statusSearch(item)"
                    >{{ item.name }}</el-button
                >
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-input
                    v-model="strFilter"
                    placeholder="快速筛选"
                    v-on:keyup.enter.native="search"
                    ref="searchinput"
                >
                    <!-- <i slot="suffix" class="el-input__icon el-icon-search"></i> -->
                    <el-button
                        slot="append"
                        class="el-append-search"
                        @click="search()"
                        >查询</el-button
                    >
                    <el-button slot="append" @click="selectRow(-1)"
                        >回传空值</el-button
                    >
                    <el-button
                        slot="append"
                        @click="importOutData()"
                        v-if="type != '会计科目' && moduleMark == 'POS'"
                        >导出数据</el-button
                    >
                    <el-button
                        slot="append"
                        @click="syncAdd()"
                        v-if="CurrnetMID == '1' || CurrnetMID == '2'"
                        >同步新增</el-button
                    >
                </el-input>
            </el-col>
        </el-row>

        <el-table
            :data="tableData"
            size="mini"
            border
            :highlight-current-row="true"
            class="toggletable"
            :row-class-name="getrowclass"
            @row-click="rowMethod"
        >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="选择" width="100">
                <template slot-scope="scope">
                    <el-button
                        v-show="scope.row.isDetailSubj || type != '会计科目'"
                        type
                        size="mini"
                        class="myshowup"
                        @click="selectRow(scope.$index)"
                        >选择</el-button
                    >
                </template>
            </el-table-column>
            <el-table-column
                label="编码"
                prop="subjectCode"
                v-if="type == '会计科目'"
            ></el-table-column>
            <el-table-column
                label="名称"
                prop="subjectName"
                v-if="type == '会计科目'"
            ></el-table-column>
            <el-table-column
                label="助记码"
                prop="helperCode"
                v-if="type == '会计科目'"
            ></el-table-column>
            <el-table-column
                label="全名"
                prop="fullSubjectName"
                v-if="type == '会计科目'"
                min-width="180"
            ></el-table-column>
            <el-table-column
                label="辅助核算"
                prop="auxiliaryAccount"
                v-if="type == '会计科目'"
            ></el-table-column>
            <el-table-column
                label="ID"
                prop="id"
                v-if="type != '会计科目' && moduleMark == 'POS'"
            ></el-table-column>
            <el-table-column
                label="编码"
                prop="code"
                v-if="type != '会计科目'"
            ></el-table-column>
            <el-table-column
                label="名称"
                prop="name"
                v-if="type != '会计科目'"
            ></el-table-column>
            <el-table-column
                label="类别"
                prop="typeName"
                v-if="type == '门店收入类型'"
            ></el-table-column>
            <el-table-column
                label="品牌编码"
                prop="brandCode"
                v-if="type == '门店收入类型'"
            ></el-table-column>
            <el-table-column
                label="品牌名称"
                prop="brandName"
                v-if="type == '门店收入类型'"
            ></el-table-column>
            <el-table-column
                label="所属大类编码"
                prop="typeCode"
                v-if="
                    type == '品项小类' || type == '品项' || type == '品项中类'
                "
            ></el-table-column>
            <el-table-column
                label="所属大类名称"
                prop="typeName"
                v-if="
                    type == '品项小类' || type == '品项' || type == '品项中类'
                "
            ></el-table-column>
            <el-table-column
                label="所属小类编码"
                prop="smallTypeCode"
                v-if="type == '品项'"
            ></el-table-column>
            <el-table-column
                label="所属小类名称"
                prop="smallTypeName"
                v-if="type == '品项'"
            ></el-table-column>
        </el-table>

        <pagerBar
            ref="refPagerBar"
            :apiURL="getDataUrl"
            :GetData="initData"
            :queryParam="queryParam"
            :errorFunc="closeOpenloading"
        ></pagerBar>
        <el-table
            :data="basicPosData"
            size="mini"
            border
            class="toggletable"
            ref="detail"
            id="ExcelOutPosData"
            hidden
        >
            <el-table-column
                label="ID"
                prop="id"
                v-if="type != '会计科目' && moduleMark == 'POS'"
            ></el-table-column>
            <el-table-column
                label="编码"
                prop="code"
                v-if="type != '会计科目'"
            ></el-table-column>
            <el-table-column
                label="名称"
                prop="name"
                v-if="type != '会计科目'"
            ></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button
                type="info"
                size="medium"
                @click="closeSelect"
                icon="el-icon-close"
                >取 消</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import SubjectService from '../../services/voucher/SubjectService'

import pagerBar from '@/views/pager/pagerBar'
import config from '../../common/config'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import AjaxHelper from '@/common/js/AjaxHelper'

export default {
    components: {
        pagerBar
    },
    data() {
        return {
            basicPosData: [],
            CurrnetMID: 0,
            incomeType: '0',
            incomeTypeList: [
                { id: '0', name: '全部' },
                { id: '1', name: '大类' },
                { id: '2', name: '小类' },
                { id: '3', name: '品项' }
            ],
            dataLoading: false,
            Visible: false,
            loading: true,
            index: 0,
            type: '',
            title: '',
            queryParam: {},
            newqueryParam: {},
            strFilter: '',
            getDataUrl:
                config.BASE_Middle_API + 'SubjectDetails/OppositeSubjects',
            downLoadExcelUrl:
                config.BASE_Middle_API + 'SubjectDetails/GetSubjectFieldDatas',
            tableData: [],
            moduleMark: '',
            isformula: false,
            inComeItemTypeList: []
        }
    },
    methods: {
        statusSearch(item) {
            const _this = this
            _this.CurrnetMID = item.id
            _this.incomeType = item.id
            _this.newqueryParam.incomeType = item.id
            _this.dataLoading = true
            _this.$refs.refPagerBar.ChangeQueryParam(_this.newqueryParam)
        },
        search() {
            this.newqueryParam.strFilter = this.strFilter.trim()
            this.$refs.refPagerBar.ChangeQueryParam(this.newqueryParam)
        },
        syncAdd() {
            const _this = this
            _this.dataLoading = true
            let itemTypeModel = {}
            itemTypeModel.itemTypeId = _this.CurrnetMID
            itemTypeModel.brandId = _this.newqueryParam.brandID
            itemTypeModel.storeId = _this.newqueryParam.storeId
            SubjectService.syncAddItemType(itemTypeModel)
                .then((r) => {
                    if (r.success) {
                        _this.dataLoading = false
                        _this.inComeItemTypeList = r.result
                        _this.$emit(
                            'syncAddItemType',
                            _this.inComeItemTypeList,
                            _this.index
                        )
                        _this.closeSelect()
                    }
                })
                .catch((e) => {
                    _this.dataLoading = false
                })
        },
        openSelect(
            index,
            type,
            accountConfInfoValue,
            brandValue,
            moduleMark,
            storeId,
            isMultiOrg,
            isformula
        ) {
            this.dataLoading = true
            this.tableData = []

            this.Visible = true
            this.index = index
            this.type = type
            this.moduleMark = moduleMark
            this.title = '请选择' + type
            this.getDataUrl =
                config.BASE_Middle_API +
                'SubjectDetails/' +
                (type == '会计科目'
                    ? 'OppositeSubjects'
                    : 'SubjectFieldDataForSelect')

            this.newqueryParam.fieldName = type
            this.newqueryParam.brandID = brandValue
            this.newqueryParam.accountId = accountConfInfoValue
            this.strFilter = ''
            this.newqueryParam.strFilter = ''
            this.newqueryParam.storeId = storeId
            this.newqueryParam.isMultiOrg = isMultiOrg
            this.newqueryParam.incomeType = this.incomeType
            this.isformula = isformula

            if (this.$refs.refPagerBar != undefined) {
                this.$refs.refPagerBar.ChangeApiURL(
                    this.getDataUrl,
                    this.newqueryParam
                )
            } else {
                this.queryParam = this.newqueryParam
            }
            this.$nextTick(function () {
                this.$refs.searchinput.focus()
            })
        },
        selectRow(index) {
            this.strFilter = ''
            this.Visible = false
            if (index == -1) {
                if (this.isformula) {
                    this.$emit(
                        'selectValueFormula',
                        this.index,
                        this.type,
                        null
                    )
                } else {
                    this.$emit('selectValue', this.index, this.type, null)
                }
            } else {
                if (this.isformula) {
                    this.$emit(
                        'selectValueFormula',
                        this.index,
                        this.type,
                        this.tableData[index]
                    )
                } else {
                    this.$emit(
                        'selectValue',
                        this.index,
                        this.type,
                        this.tableData[index]
                    )
                }
            }
            this.tableData = []
        },
        rowMethod(row) {
            if (row.isDetailSubj || this.type != '会计科目') {
                if (this.isformula) {
                    this.$emit('selectValueFormula', this.index, this.type, row)
                } else {
                    this.$emit('selectValue', this.index, this.type, row)
                }
                this.tableData = []
                this.Visible = false
            }
        },
        initData(d) {
            this.tableData = d
            this.dataLoading = false
            this.loading = false
        },
        closeSelect() {
            this.strFilter = ''
            this.Visible = false
        },
        closeOpenloading() {
            this.dataLoading = false
            this.loading = false
        },
        getrowclass({ row, rowindex }) {
            if (row.isDetailSubj || this.type != '会计科目') {
                return ''
            } else {
                return 'graybg'
            }
        },
        importOutData() {
            const _this = this
            AjaxHelper.get(_this.downLoadExcelUrl, _this.newqueryParam)
                .then((res) => {
                    if (res.success) {
                        _this.basicPosData = res.result
                        if (_this.basicPosData.length <= 0) {
                            _this.$notify({
                                title: '提示',
                                message: '当前无可导出的数据',
                                type: 'error',
                                position: 'bottom-right'
                            })
                            return false
                        } else {
                            _this.dataLoading = true
                            _this.$nextTick(function () {
                                _this.downExcel()
                            })
                            _this.dataLoading = false
                        }
                    }
                })
                .catch(function (error) {})
        },
        downExcel() {
            /* 从表生成工作簿对象 */
            let fix = document.querySelector('.el-table__fixed')
            let wb
            var xlsxParam = { raw: true }
            if (fix) {
                //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#ExcelOutPosData').removeChild(fix),
                    xlsxParam
                )
                document.querySelector('#ExcelOutPosData').appendChild(fix)
            } else {
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#ExcelOutPosData'),
                    xlsxParam
                )
            }
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            })
            try {
                FileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    //设置导出文件名称
                    this.type + '.xlsx'
                )
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout)
            }

            return wbout
        }
    }
}
</script>

<style>
.myshowup.el-button {
    border-radius: 16px;
}
.el-append-search {
    background-color: #409eff !important;
    color: #fff !important;
}
.graybg {
    background: #f9f9f9 !important;
}
</style>
